import React from "react";
import { Helmet } from "react-helmet-async";
import { BUSINESS } from "@/content/site";

/**
 * Injects <head> metadata: title, description, canonical, hreflang, OG, Twitter,
 * verification tokens, and JSON-LD schema.
 */
export default function Seo({ page, path, lang, pair, schema, noindex }) {
  if (!page) return null;
  const canonical = `${BUSINESS.baseUrl}${path}`;
  // [2026-09-22 crawl fix] Untranslated pages must NOT claim the other-
  // language homepage as a translation (the old `pair || "/"` fallback
  // created conflicting hreflang clusters). No pair => self-reference only:
  // own language + x-default point at this page; the other language link is
  // omitted entirely.
  const pairUrl = pair ? `${BUSINESS.baseUrl}${pair}` : null;
  const enUrl = lang === "en" ? canonical : pairUrl;
  const esUrl = lang === "es" ? canonical : pairUrl;
  const xDefaultUrl = enUrl || canonical;
  const ogLocale = lang === "es" ? "es_MX" : "en_US";
  const ogImage = `${BUSINESS.baseUrl}/images/og-default.jpg`;
  const pageOgImage = page.ogImage
    ? (page.ogImage.startsWith("http") ? page.ogImage : `${BUSINESS.baseUrl}${page.ogImage}`)
    : ogImage;
  const robotsContent = noindex
    ? "noindex,nofollow"
    : "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1";

  return (
    <Helmet>
      <html lang={lang} />
      <title>{page.title}</title>
      <meta name="description" content={page.description || ""} />
      {!noindex && <link rel="canonical" href={canonical} />}
      {!noindex && enUrl && <link rel="alternate" hrefLang="en" href={enUrl} />}
      {!noindex && esUrl && <link rel="alternate" hrefLang="es" href={esUrl} />}
      {!noindex && <link rel="alternate" hrefLang="x-default" href={xDefaultUrl} />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Garcia-Windsor, P.C." />
      <meta property="og:locale" content={ogLocale} />
      <meta property="og:title" content={page.title} />
      <meta property="og:description" content={page.description || ""} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={pageOgImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={page.title} />
      <meta name="twitter:description" content={page.description || ""} />
      <meta name="twitter:image" content={pageOgImage} />
      <meta name="google-site-verification" content="KxKYtl4f7RsOGBkDQCxORqDxp1WCPTDw3drjoC4zbSc" />
      <meta name="msvalidate.01" content="24D7A9183DB8BD89BE04B82D87A134E0" />
      <meta name="robots" content={robotsContent} />
      <meta name="author" content="Garcia-Windsor, P.C." />
      <meta name="theme-color" content="#7A1B2A" />
      {schema && !noindex && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
